import { useLang } from "./ctx";

export const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <section className="overflow-hidden border-b border-stone-200 bg-[#FBFAF7] py-10 lg:py-14" data-testid="editorial-marquee">
      <div className="marquee flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center whitespace-nowrap font-display text-5xl font-light tracking-tight text-stone-900 sm:text-7xl lg:text-8xl">
                <span className={i % 2 ? "italic text-[#A8874F]" : ""}>{w}</span>
                <img src="/assets/icon-dark.png" alt="" className="mx-10 h-8 w-auto opacity-70 lg:mx-16 lg:h-12" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
